const pageView = data => {
    try {
        if (window.axon) {
            console.log(data)
            const {
                productId,
                amount,
                currency
            } = data
            window.axon("track", "view_item", {
                "currency": currency, "value": amount, items: [{
                    "item_id": productId,
                    "item_name": productId,
                    "price": amount,
                    "quantity": 1,
                    "item_category_id":166,
                    "item_variant_id":productId,
                    "image_url":"https://image.geeko.ltd/small/20240415_01.jpg"
                }]
            });
        }
    } catch (e) {
        console.warn(e)
    }
}

const addToCart = data => {
    try {
        if (window.axon) {
            const {
                productId,
                amount,
                currency,
                quantity
            } = data

            window.axon("track", "add_to_cart", {
                "currency": currency, "value": amount, items: [{
                    "item_id": productId,
                    "item_name": productId,
                    "price": amount,
                    "quantity": quantity,
                    "item_category_id":166,
                    "item_variant_id":productId,
                    "image_url":"https://image.geeko.ltd/small/20240415_01.jpg"
                }]
            });
        }
    } catch (e) {
        console.warn(e)
    }
}

const purchase = data => {
    try {
        console.log("axon------------------------------------------")
        if (window.axon) {
            const {
                transactionId,
                orderTotal,
                orderItems
            } = data
            const items = orderItems.map(item => {
                return {
                    "item_id": item.productId,
                    "item_name": item.productId,
                    "quantity": item.quantity,
                    "price": item.price?.amount,
                    "item_category_id":166,
                    "item_variant_id":item.productId,
                    "image_url":"https://image.geeko.ltd/small/20240415_01.jpg"
                }
            })

            window.axon("track", "purchase", {
                "currency": orderTotal?.currency, "value": orderTotal?.amount,
                "transaction_id": transactionId,
                items: items
            });
        }
    } catch (e) {
        console.warn(e)
    }
}

export default {
    addToCart,
    pageView,
    purchase
}